export const getPackageVersion = () => {return "2.19.2";}; // Avoid manual modification.